export const roles = {
  admin: 'ROLE_ADMIN',
  user: 'ROLE_USER',
  adminReadOnly: 'ROLE_READ_ADMIN',
}
